import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ISubmitResponse } from '@interfaces/models/ISubmitResponse';
import { IOpenAccount } from '@interfaces/open-account/oa.interface';
import { RecaptchaMockResult } from '@interfaces/submit/submit.service.interface';
import { FMFResponse } from '@shared/services/fraud-micro-frontend/fmf.service';
import { FraudOutcome } from '@store/reducers/fraud-detector-simulator/fraud-detector-simulator.reducer';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OpenAccountSubmitService {
  constructor(private http: HttpClient) {}

  openAccount(
    openAccountData: IOpenAccount,
    fmfResponse: FMFResponse,
    mockFraudDetectorLevel: FraudOutcome,
    mockRecaptchaLevel: RecaptchaMockResult,
  ): Observable<ISubmitResponse> {
    return this.http.post<ISubmitResponse>(`secure/submit-oaa`, {
      ...openAccountData,
      fmfResponse,
      mockFraudDetectorLevel,
      mockRecaptchaLevel,
    });
  }
}
